import type {ComponentType} from 'react';

import {FrontBumper} from '../CarDiagram/parts/exterior/FrontBumper';
import {FrontLeftDoor} from '../CarDiagram/parts/exterior/FrontLeftDoor';
import {FrontLeftHeadlight} from '../CarDiagram/parts/exterior/FrontLeftHeadlight';
import {FrontLeftSidePanel} from '../CarDiagram/parts/exterior/FrontLeftSidePanel';
import {FrontRightDoor} from '../CarDiagram/parts/exterior/FrontRightDoor';
import {FrontRightHeadlight} from '../CarDiagram/parts/exterior/FrontRightHeadlight';
import {FrontRightSidePanel} from '../CarDiagram/parts/exterior/FrontRightSidePanel';
import {FrontWindshield} from '../CarDiagram/parts/exterior/FrontWindshield';
import {Grille} from '../CarDiagram/parts/exterior/Grille';
import {Hood} from '../CarDiagram/parts/exterior/Hood';
import {RearBumper} from '../CarDiagram/parts/exterior/RearBumper';
import {RearLeftDoor} from '../CarDiagram/parts/exterior/RearLeftDoor';
import {RearLeftSidePanel} from '../CarDiagram/parts/exterior/RearLeftSidePanel';
import {RearLeftTaillight} from '../CarDiagram/parts/exterior/RearLeftTaillight';
import {RearRightDoor} from '../CarDiagram/parts/exterior/RearRightDoor';
import {RearRightSidePanel} from '../CarDiagram/parts/exterior/RearRightSidePanel';
import {RearRightTaillight} from '../CarDiagram/parts/exterior/RearRightTaillight';
import {RearWindshield} from '../CarDiagram/parts/exterior/RearWindshield';
import {RoofSunroof} from '../CarDiagram/parts/exterior/RoofSunroof';
import {TowBar} from '../CarDiagram/parts/exterior/TowBar';
import {Trunk} from '../CarDiagram/parts/exterior/Trunk';
import {CenterConsole} from '../CarDiagram/parts/interior/CenterConsole';
import {DashboardMiddleHeating} from '../CarDiagram/parts/interior/DashboardMiddleHeating';
import {DriverSeat} from '../CarDiagram/parts/interior/DriverSeat';
import {FrontLeftDoorInterior} from '../CarDiagram/parts/interior/FrontLeftDoor';
import {FrontRightDoorInterior} from '../CarDiagram/parts/interior/FrontRightDoor';
import {PassengerSeat} from '../CarDiagram/parts/interior/PassengerSeat';
import {RearLeftDoorInterior} from '../CarDiagram/parts/interior/RearLeftDoor';
import {RearLeftSidePanelInterior} from '../CarDiagram/parts/interior/RearLeftSidePanel';
import {RearRightDoorInterior} from '../CarDiagram/parts/interior/RearRightDoor';
import {RearRightSidePanelInterior} from '../CarDiagram/parts/interior/RearRightSidePanel';
import {RearSeats} from '../CarDiagram/parts/interior/RearSeats';
import {SteeringWheel} from '../CarDiagram/parts/interior/SteeringWheel';
import {TrunkInterior} from '../CarDiagram/parts/interior/Trunk';
import type {PartMode} from '../CarDiagram/parts/shared/PartSvg';

export type PartIllustrationComponent = ComponentType<{readonly mode?: PartMode}>;

export const PART_ILLUSTRATIONS: Record<string, PartIllustrationComponent> = {
  'front-bumper': FrontBumper,
  'front-left-door': FrontLeftDoor,
  'front-left-headlight': FrontLeftHeadlight,
  'front-left-side-panel': FrontLeftSidePanel,
  'front-right-door': FrontRightDoor,
  'front-right-headlight': FrontRightHeadlight,
  'front-right-side-panel': FrontRightSidePanel,
  'front-windshield': FrontWindshield,
  grille: Grille,
  hood: Hood,
  'rear-bumper': RearBumper,
  'rear-left-door': RearLeftDoor,
  'rear-left-side-panel': RearLeftSidePanel,
  'rear-left-taillight': RearLeftTaillight,
  'rear-right-door': RearRightDoor,
  'rear-right-side-panel': RearRightSidePanel,
  'rear-right-taillight': RearRightTaillight,
  'rear-windshield': RearWindshield,
  roof: RoofSunroof,
  'tow-bar': TowBar,
  trunk: Trunk,

  'center-console': CenterConsole,
  'dashboard-middle-heating': DashboardMiddleHeating,
  'driver-seat': DriverSeat,
  'front-left-door-interior': FrontLeftDoorInterior,
  'front-right-door-interior': FrontRightDoorInterior,
  'passenger-seat': PassengerSeat,
  'rear-left-door-interior': RearLeftDoorInterior,
  'rear-left-side-panel-interior': RearLeftSidePanelInterior,
  'rear-right-door-interior': RearRightDoorInterior,
  'rear-right-side-panel-interior': RearRightSidePanelInterior,
  'rear-seats': RearSeats,
  'steering-wheel': SteeringWheel,
  'trunk-interior': TrunkInterior,
};

export function getPartIllustration(partId: string): PartIllustrationComponent | undefined {
  return PART_ILLUSTRATIONS[partId];
}
